export type PartyGroupColorSource = {
  profiles?: Array<{
    participantGroups?: Array<{ color?: string | null } | null> | null;
  } | null> | null;
  participantGroup?: { color?: string | null } | null;
} | null | undefined;

/** First non-empty participant group color on a person or company party. */
export function pickPartyGroupColor(
  party: PartyGroupColorSource
): string | null {
  const fromProfile = party?.profiles
    ?.flatMap((profile) => profile?.participantGroups ?? [])
    .find((group) => group?.color)?.color;
  if (fromProfile) return fromProfile;
  return party?.participantGroup?.color ?? null;
}

/**
 * Color of the other party on a connection row (the person/company the
 * current viewer is connected to). Uses already-loaded relations only.
 */
export function pickCounterpartyGroupColor(
  item: {
    senderId?: string | null;
    senderUser?: PartyGroupColorSource;
    senderExhibitor?: PartyGroupColorSource;
    senderSponsor?: PartyGroupColorSource;
    receiverUser?: PartyGroupColorSource;
    receiverExhibitor?: PartyGroupColorSource;
    receiverSponsor?: PartyGroupColorSource;
  },
  entityIds: string[]
): string | null {
  const mine = new Set(entityIds.filter(Boolean));
  const iAmSender = item.senderId ? mine.has(item.senderId) : false;
  if (iAmSender) {
    return (
      pickPartyGroupColor(item.receiverUser) ??
      pickPartyGroupColor(item.receiverExhibitor) ??
      pickPartyGroupColor(item.receiverSponsor)
    );
  }
  return (
    pickPartyGroupColor(item.senderUser) ??
    pickPartyGroupColor(item.senderExhibitor) ??
    pickPartyGroupColor(item.senderSponsor)
  );
}

/** Lean Prisma select: type + color only (indexed _id lookups, no extra scans). */
export const participantGroupColorSelect = {
  select: {
    type: true,
    color: true,
  },
} as const;
